import { MantineReactTable, type MRT_ColumnDef } from 'mantine-react-table'
import { useMemo } from 'react'
import { Place, TableType, TableVariant } from 'types/products'
import { placeFilterFn } from 'utils'
import { sizeSortingFn, useProductTable } from './ProductTable'

type Props = {
  variants: Array<TableVariant>
  highlightItemId?: string
}

export default function TableTableProduct({ variants, highlightItemId }: Props) {
  const columns = useMemo<Array<MRT_ColumnDef<TableVariant>>>(
    () => [
      {
        accessorKey: 'tableType',
        header: 'Rodzaj',
        size: 100,
        Cell: ({ cell }) => {
          const tableType = cell.getValue<TableType>()
          switch (tableType) {
            case TableType.TABLECLOTH:
              return 'Obrus'
            case TableType.TABLE_RUNNER:
              return 'Bieżnik'
            case TableType.NAPKIN:
              return 'Serwetka'
            default:
              return 'Nieznany rodzaj'
          }
        },
        filterVariant: 'select',
        mantineFilterSelectProps: {
          data: Object.values(TableType).map((place) => ({
            value: place,
            label: place === TableType.TABLECLOTH ? 'Obrus' : place === TableType.TABLE_RUNNER ? 'Bieżnik' : 'Serwetka',
          })),
        },
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po rodzaju',
        },
      },
      {
        accessorKey: 'size',
        header: 'Wymiar (cm)',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po wymiarze',
        },
        sortingFn: sizeSortingFn,
      },
      {
        accessorKey: 'stock',
        header: 'Ilość sztuk',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po ilości',
        },
      },
      {
        accessorKey: 'place',
        header: 'Półka',
        enableSorting: false,
        size: 100,
        Cell: ({ cell }) => {
          const place = cell.getValue<Place>()
          return `${place.rack}-${place.column}-${place.shelf}`
        },
        filterFn: placeFilterFn,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po półce',
        },
      },
      {
        accessorKey: 'feature',
        header: 'Cecha',
        enableSorting: false,
        size: 120,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po cesze',
        },
      },
      {
        accessorKey: 'comments',
        header: 'Uwagi',
        enableSorting: false,
        size: 120,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po uwagach',
        },
      },
    ],
    []
  )
  const table = useProductTable({
    columns,
    data: variants,
    highlightItemId,
  })
  return <MantineReactTable table={table} />
}
